import PropTypes from 'prop-types'
import React from 'react'

import FaqGut from 'components/FaqGut'
import SectionWrapper from 'components/SectionWrapper'
import { Col, Row } from 'styles/components/layout'

import { H2Styled, TextStyled } from './styles'

const BAboutQuestions = ({ data, isMobile }) => {
  return (
    <SectionWrapper isOverflowHidden={true} isWideToDesktop={isMobile}>
      <Row>
        <Col width={{ xs: 1 }}>
          <div>
            {data.description ? (
              <TextStyled
                dangerouslySetInnerHTML={{ __html: data.description }}
              />
            ) : null}
            {data.title ? (
              <H2Styled
                as={'h3'}
                dangerouslySetInnerHTML={{ __html: data.title }}
              />
            ) : null}
            <FaqGut theme="gray" isMobile={isMobile} data={data.list} />
          </div>
        </Col>
      </Row>
    </SectionWrapper>
  )
}

BAboutQuestions.propTypes = {
  data: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
}

BAboutQuestions.defaultProps = {
  isMobile: false,
}

export default BAboutQuestions
